/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type EmailDrilldownMutationInput = {
    email: Array<string>;
    entityRef: string;
    category: string;
    clientMutationId?: string | null;
};
export type EmailDrilldownMutationVariables = {
    input: EmailDrilldownMutationInput;
};
export type EmailDrilldownMutationResponse = {
    readonly emailDrilldown: {
        readonly clientMutationId: string | null;
        readonly accepted: ReadonlyArray<string>;
        readonly rejected: ReadonlyArray<string>;
    } | null;
};
export type EmailDrilldownMutation = {
    readonly response: EmailDrilldownMutationResponse;
    readonly variables: EmailDrilldownMutationVariables;
};



/*
mutation EmailDrilldownMutation(
  $input: EmailDrilldownMutationInput!
) {
  emailDrilldown(input: $input) {
    clientMutationId
    accepted
    rejected
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailDrilldownMutationPayload",
    "kind": "LinkedField",
    "name": "emailDrilldown",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accepted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rejected",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailDrilldownMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailDrilldownMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d47b924290a69d423f0dbf8873df30b6",
    "id": null,
    "metadata": {},
    "name": "EmailDrilldownMutation",
    "operationKind": "mutation",
    "text": "mutation EmailDrilldownMutation(\n  $input: EmailDrilldownMutationInput!\n) {\n  emailDrilldown(input: $input) {\n    clientMutationId\n    accepted\n    rejected\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bf930979d042319634e719c02dd973cf';
export default node;
